import { makeQueryFormDataDyn, errorServeiceHandler } from '../../helper'
const state = {
};
const getters = {
};
const mutations = {
};

const actions = {

    uploadCSVFile: (context, formData) => {
        console.log("reached")
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/fileupload.php', {
                method: 'POST',
                body: formData
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.text();
                }).then((data) => {
                    console.log("data", data)
                    resolve(data)

                }).catch((error) => {
                    console.log("error", error)
                    reject(error);
                });
        });
    },
    activateCSV: (context, formData) => {
        console.log(formData)
        let url = formData.url
        delete formData.url
        return new Promise((resolve, reject) => {
            let param = makeQueryFormDataDyn(formData)
            fetch(context.getters.baseUrl + '/lco/v1' + url, {
                method: 'POST',
                body: param
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.text()
                }).then((data) => {

                    resolve(data)

                }).catch((error) => {
                    console.log("error", error)

                    reject(error);
                });
        });
    },
    downloadCSVFile: (context) => {
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/bulkactivatetemplatedownload.php', {
                method: 'GET',
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.text()
                }).then((data) => {

                    resolve(data)

                }).catch((error) => {

                    reject(error);
                });
        });
    }
};
export default {
    state, getters, mutations, actions
};



// WEBPACK FOOTER //
// ./src/store/modules/productModule/bulkModule.js